import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./Pill.css";
import * as React from "react";
import { Button } from '../../Button';
import { Icon } from '../../Icon';
import * as Resources from '../../Resources.Widgets';
import { css, getSafeId } from '../../Util';
import { darken, getColorString, isDark } from '../../Utilities/Color';
import { getTabIndex } from '../../Utilities/Focus';
var Pill = /** @class */ (function (_super) {
    tslib_1.__extends(Pill, _super);
    function Pill(props) {
        var _this = _super.call(this, props) || this;
        _this.onKeyDown = function (event) {
            var keyCode = event.which;
            if (keyCode === 13 /* enter */) {
                _this.props.onClick && _this.props.onClick();
            }
        };
        _this.onMouseEnter = function (event) {
            _this.props.onMouseEnter && _this.props.onMouseEnter(event);
            _this.setState({
                isHoveringPrimaryElement: true
            });
        };
        /**
         * onMouseLeaveButton fires first; if it leaves the container too
         * onMouseLeave will setState again, which will prevent weird behavior
         */
        _this.onMouseLeave = function (event) {
            _this.props.onMouseLeave && _this.props.onMouseLeave(event);
            _this.setState({
                isHoveringPrimaryElement: false
            });
        };
        _this.onMouseLeaveButton = function () {
            _this.setState({
                isHoveringPrimaryElement: true
            });
        };
        _this.onMouseOverButton = function () {
            _this.setState({
                isHoveringPrimaryElement: false
            });
        };
        _this.state = {
            isHoveringPrimaryElement: false
        };
        return _this;
    }
    Pill.getColorStyle = function (color, isHoveringPrimaryElement, onClick) {
        if (!color) {
            return undefined;
        }
        var renderColor = onClick && isHoveringPrimaryElement ? darken(color, 0.06) : color;
        return { backgroundColor: getColorString(renderColor) };
    };
    Pill.getSizeClass = function (size) {
        switch (size) {
            case 0 /* compact */:
                return "compact";
            case 2 /* large */:
                return "large";
            case 1 /* regular */:
            default:
                return "regular";
        }
    };
    Pill.getVariantClass = function (variant, color) {
        switch (variant) {
            case 1 /* outlined */:
                return "outlined";
            case 2 /* colored */:
                if (color) {
                    return css("colored", isDark(color) ? "dark" : "light");
                }
                else {
                    return "standard";
                }
            case 0 /* standard */:
            default:
                return "standard";
        }
    };
    Pill.getDerivedStateFromProps = function (props, state) {
        if ($DEBUG) {
            var color = props.color, iconProps = props.iconProps, onRemoveClick = props.onRemoveClick, onRenderFilledVisual = props.onRenderFilledVisual, _a = props.size, size = _a === void 0 ? 1 /* regular */ : _a, variant = props.variant;
            // Checking for unsupported compact fields and warning if there are any
            if (size === 0 /* compact */) {
                var unsupportedFields = [];
                iconProps && unsupportedFields.push("onRemoveClick");
                onRemoveClick && unsupportedFields.push("onRemoveClick");
                onRenderFilledVisual && unsupportedFields.push("onRenderFilledVisual");
                if (unsupportedFields.length > 0) {
                    console.warn("Pill Size is Compact, but the following fields were provided: " + unsupportedFields.join(", ") + " - these will be ignored. Consider changing Pill Size to Regular or Large if you need to support these items");
                }
            }
            else {
                if (onRenderFilledVisual && iconProps) {
                    console.warn("onRenderFilledVisual and iconProps have both been supplied; using onRenderFilledVisual");
                }
            }
            if (variant === 2 /* colored */ && !color) {
                console.warn("Pill Variant is set to Colored, but not color was provided - Pill will render as Standard");
            }
            else if (color && variant !== 2 /* colored */) {
                console.warn("Color was provided, but Pill Variant is not set to Colored - Pill will render as whatever variant was provided");
            }
        }
        return state;
    };
    Pill.prototype.render = function () {
        var _a = this.props, contentClassName = _a.contentClassName, className = _a.className, color = _a.color, _b = _a.containsCount, containsCount = _b === void 0 ? false : _b, iconProps = _a.iconProps, id = _a.id, onClick = _a.onClick, onRemoveClick = _a.onRemoveClick, onRenderFilledVisual = _a.onRenderFilledVisual, _c = _a.size, size = _c === void 0 ? 1 /* regular */ : _c, _d = _a.variant, variant = _d === void 0 ? 0 /* standard */ : _d;
        var isHoveringPrimaryElement = this.state.isHoveringPrimaryElement;
        return (React.createElement("div", { className: css(className, "bolt-pill flex-row flex-noshrink", Pill.getVariantClass(variant, color), Pill.getSizeClass(size), containsCount && "count", isHoveringPrimaryElement && "hover", onClick && "clickable"), id: getSafeId(id), onClick: onClick, onKeyDown: this.onKeyDown, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, style: Pill.getColorStyle(color, isHoveringPrimaryElement, onClick), tabIndex: getTabIndex(this.props) },
            onRenderFilledVisual && React.createElement("div", { className: "bolt-pill-filled-visual flex-noshrink" }, onRenderFilledVisual()),
            iconProps && !onRenderFilledVisual && React.createElement(Icon, tslib_1.__assign({}, iconProps, { className: css(iconProps.className, "bolt-pill-icon") })),
            React.createElement("div", { className: css(contentClassName, "bolt-pill-content") }, this.props.children),
            onRemoveClick && (React.createElement(Button, { ariaLabel: Resources.RemovePillLabel, className: "bolt-pill-button", iconProps: { iconName: "Cancel" }, onClick: onRemoveClick, onMouseLeave: this.onMouseLeaveButton, onMouseOver: this.onMouseOverButton, subtle: true }))));
    };
    return Pill;
}(React.Component));
export { Pill };
